import { generateTestId } from "@client-shared";

export const setSsSkuDraftsModalTestId = (identifier: string): string => generateTestId("SsSkuDraftsModal", identifier);
